// extracted by mini-css-extract-plugin
module.exports = {"img":"myimg_img__29U6a","img-homelist":"myimg_img-homelist__1723_","img-record":"myimg_img-record__2iSlh","img-touxiang":"myimg_img-touxiang__Bm8MY"};